import Swal from "sweetalert2";
// import '../styles/custom.css'

/**
 * Show a confirmation alert with SweetAlert2
 * @param {string} title - The title of the alert
 * @param {string} text - The message of the alert
 * @returns {Promise<boolean>} - Returns true if confirmed, false otherwise
 */
export const showConfirmation = async (title = "Are you sure?", text = "You won't be able to revert this!") => {
    const result = await Swal.fire({
        title,
        text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28A745",
        cancelButtonColor: "#DC3545",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        customClass: {
            popup: 'custom-swal-popup' // Add a custom class to the popup
        }
    });
    return result.isConfirmed; // Returns true if "Yes" is clicked, otherwise false
};

export const showSignupPopup = async () => {
    const result = await Swal.fire({
        title: "⚠️ Important Notice",
        html: `
            <div style="text-align:left; font-size:14px;">
                <p style="color:red; font-weight:bold;">
                    DBATU Students – Do Not Register Again
                </p>

                <p>
                    Students belonging to Dr. Babasaheb Ambedkar Technological University (DBATU) must not register again on this portal.
                </p>

                <p>
                    All DBATU students have already been registered by their respective institutes, and their login credentials have been sent to the email ID provided to their institute.
                </p>

                <p>
                    If you are a DBATU student and have not received your credentials, please contact your respective institute instead of creating a new account.
                </p>

                <p><b>For Institutes affiliated with DBATU:</b></p>
                <p>
                    Please do not register separately on this portal. DBATU is the only institute authorized to monitor and manage this course.
                </p>

                <div style="margin-top:15px;">
                    <input type="checkbox" id="confirmCheck" />
                    <label for="confirmCheck"> I understand and wish to continue</label>
                </div>
            </div>
        `,

        showCancelButton: true,
        confirmButtonText: "Proceed to Signup",
        cancelButtonText: "Back to Login",

        confirmButtonColor: "#28A745",
        cancelButtonColor: "#DC3545",

        allowOutsideClick: false,
        allowEscapeKey: false,

        didOpen: () => {
            const confirmBtn = Swal.getConfirmButton();
            confirmBtn.disabled = true;

            const checkbox = document.getElementById("confirmCheck");

            checkbox.addEventListener("change", () => {
                confirmBtn.disabled = !checkbox.checked;
            });
        }
    });

    return result.isConfirmed; // true = Proceed
};

/**
 * Show a success alert
 * @param {string} message - The message to display
 */
export const showSuccess = (message = "Action completed successfully!") => {
    Swal.fire("Success!", message, "success");
};

/**
 * Show an error alert
 * @param {string} message - The error message to display
 */
export const showError = (message = "Something went wrong!") => {
    Swal.fire("Error!", message, "error");
};
